export enum DataTypeEnum {
    CaseSubjects = "CaseSubjects",
    TicketStatuses = "TicketStatuses",
    ActionTypes = "ActionTypes",
    SearchCaseTicket = "SearchCaseTicket",
    ClosingChecklistTypes = "ClosingChecklistTypes",
    TicketActionTypes = "TicketActionTypes",
    PriceBands = "PriceBands",
    Clients = "Clients",
    YesNo = "YesNo",
    TicketType = "TicketType",
    ClientContacts = "ClientContacts",
    TicketActionLists = "TicketActionLists",
    AllTicketActionLists = "AllTicketActionLists",

    ConditionFormFieldKey = "ConditionFormFieldKey",
    FileUploadType = "FileUploadType",
    SubSection = "SubSection",
    FormFieldKeyDependency = "FormFieldKeyDependency",
    FormFieldKey = "FormFieldKey",
    FormFieldKeySpecialType = "FormFieldKeySpecialType",
    EntityFormFieldValueType = "EntityFormFieldValueType",
    GetUsers = "GetUsers",
    FormTemplate = "FormTemplate",
    FormStatus = "FormStatus",
    Agents = "Agents"
}
